import React from 'react';
import { Metadata } from 'components/metadata';
import { MetadataPage } from 'components/metadata/constants';
import { SearchResultsScreen } from 'features/search/SearchResults';
import { EarnTypeConstructorFilter } from 'common/api/constructor/util';
import { useRootSelector } from 'common/features/featuresReducer';
import { UserAuthState } from 'common/features/store/duck/account/duck';
import { Redirect } from 'react-router-dom';
import { Routes } from 'routes';
import { selectIsConstructorBrowseEnabledWeb } from 'common/features/store/duck/ffs';

interface ByEarnTypePageProps {
    earnType: EarnTypeConstructorFilter;
}

export const ByEarnTypePage = ({ earnType }: ByEarnTypePageProps) => {
    const notAuthenticated = useRootSelector(
        (s: any) => s.store.account.userAuthState === UserAuthState.NOTAUTHENTICATED
    );
    const isConstructorAffiliateEnabled = useRootSelector(selectIsConstructorBrowseEnabledWeb);

    if (notAuthenticated || isConstructorAffiliateEnabled === false) {
        return <Redirect to={Routes.Shop} />;
    }

    return (
        <Metadata page={MetadataPage.shop}>
            <SearchResultsScreen earnType={earnType} singleTypeView={true} />
        </Metadata>
    );
};
